import { isRejectedWithValue } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import ToastNotification from 'components/Notifications/ToastNotification'

export const rtkQueryErrorLogger = api => next => action => {
    if (isRejectedWithValue(action)) {
        const { status, message } = action.payload

        if (status >= 500 && status < 600) {
            toast(
                <ToastNotification
                    text={`${status} Something went wrong on server`}
                    icon={'error'}
                />
            )
        } else if (status === 403) {
            toast(<ToastNotification text={message || 'Unauthorized request!'} icon={'error'} />)
        } else if (status === 404) {
            toast(<ToastNotification text={`Couldn't complete the request`} icon={'error'} />)
        }
    }

    return next(action)
}
